<template>

  <v-container fluid grid-list-xl class="trip-wizard">
    
    <transition name="fade-up" mode="out-in" appear>
      <v-layout column v-if="step == 'height'" key="step_height">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My height is...</h1>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout justify-center>
            <v-flex shrink><span>Feet</span></v-flex>
          </v-layout>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(heightFeet, heightFeetIndex) in options.height.feet"
              :key="'heightFeet-' + heightFeet"
              :data-index="heightFeetIndex"
              shrink
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="circle-container"
                  :class="{'hovering':hover, 'selected':(selections.height_ft == heightFeet)}"

                  @click="setSelection('height_ft', heightFeet)"
                >
                  <div class="selected-background">
                    
                  </div>
                  <div class="hover-background"></div>
                  <div class="text-container">{{ heightFeet }}</div>
                </div>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout justify-center>
            <v-flex shrink><span>Inches</span></v-flex>
          </v-layout>

          <v-layout row justify-center class="ma-0 pa-0">
            <v-flex class="ma-0 pa-0" style="max-width: 700px;">
              <v-layout row wrap justify-center class="ma-0 pa-0">
                <v-flex
                  v-for="(heightInches, heightInchesIndex) in options.height.inches"
                  :key="'heightInches-' + heightInches"
                  :data-index="heightInchesIndex"
                  class="wrap6"
                >
                  <v-hover>
                    <div 
                      slot-scope="{ hover }"
                      class="circle-container"
                      :class="{'hovering':hover, 'selected':(selections.height_in == heightInches)}"

                      @click="setSelection('height_in', heightInches)"
                    >
                      <div class="selected-background">
                        
                      </div>
                      <div class="hover-background"></div>
                      <div class="text-container">{{ heightInches }}</div>
                    </div>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>


      <v-layout column v-if="step == 'top'" key="step_top">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My top size is...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class=""></span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(topSize, topSizeIndex) in options.top_sizes"
              :key="'topSize-' + topSizeIndex"
              :data-index="topSizeIndex"
              shrink
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="circle-container"
                  :class="{'hovering':hover, 'selected':(selections.top_size == topSize)}"

                  @click="setSelection('top_size', topSize)"
                >
                  <div class="selected-background">
                    
                  </div>
                  <div class="hover-background"></div>
                  <div class="text-container">{{ topSize }}</div>
                </div>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



      <v-layout column v-if="step == 'dress'" key="step_dress">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My dress size is...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class=""></span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(dressSize, dressSizeIndex) in options.dress_sizes"
              :key="'dressSize-' + dressSizeIndex"
              :data-index="dressSizeIndex"
              shrink
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="circle-container"
                  :class="{'hovering':hover, 'selected':(selections.dress_size == dressSize)}"

                  @click="setSelection('dress_size', dressSize)"
                >
                  <div class="selected-background">
                    
                  </div>
                  <div class="hover-background"></div>
                  <div class="text-container">{{ dressSize }}</div>
                </div>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>


      <v-layout column v-if="step == 'jean'" key="step_jean">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My jean size is...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class=""></span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row justify-center class="ma-0 pa-0">
            <v-flex class="ma-0 pa-0" style="max-width: 700px;">
              <v-layout row wrap justify-center class="ma-0 pa-0">
                <v-flex
                  v-for="(jeanSize, jeanSizeIndex) in options.jean_sizes"
                  :key="'jeanSize-' + jeanSizeIndex"
                  :data-index="jeanSizeIndex"
                  class="wrap6"
                >
                  <v-hover>
                    <div 
                      slot-scope="{ hover }"
                      class="circle-container"
                      :class="{'hovering':hover, 'selected':(selections.denim_waist_size == jeanSize)}"

                      @click="setSelection('denim_waist_size', jeanSize)"
                    >
                      <div class="selected-background">
                        
                      </div>
                      <div class="hover-background"></div>
                      <div class="text-container">{{ jeanSize }}</div>
                    </div>
                  </v-hover>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



      <v-layout column v-if="step == 'pants'" key="step_pants">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My pant size is...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class=""></span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(pantSize, pantSizeIndex) in options.pant_sizes"
              :key="'pantSize-' + pantSizeIndex"
              :data-index="pantSizeIndex"
              shrink
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="circle-container"
                  :class="{'hovering':hover, 'selected':(selections.pant_size == pantSize)}"

                  @click="setSelection('pant_size', pantSize)"
                >
                  <div class="selected-background">
                    
                  </div>
                  <div class="hover-background"></div>
                  <div class="text-container">{{ pantSize }}</div>
                </div>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>



      <v-layout column v-if="step == 'bra'" key="step_bra">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My bra size is...</h1>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout justify-center>
            <v-flex shrink><span>Size</span></v-flex>
          </v-layout>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(braSize, braSizeIndex) in options.bra_sizes"
              :key="'braSize-' + braSize"
              :data-index="braSizeIndex"
              shrink
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="circle-container"
                  :class="{'hovering':hover, 'selected':(selections.bra_size == braSize)}"

                  @click="setSelection('bra_size', braSize)"
                >
                  <div class="selected-background">
                    
                  </div>
                  <div class="hover-background"></div>
                  <div class="text-container">{{ braSize }}</div>
                </div>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout justify-center>
            <v-flex shrink><span>Cup</span></v-flex>
          </v-layout>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(cupSize, cupSizeIndex) in options.cup_sizes"
              :key="'cupSize-' + cupSize"
              :data-index="cupSizeIndex"
              shrink
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="circle-container"
                  :class="{'hovering':hover, 'selected':(selections.bra_cup_size == cupSize)}"

                  @click="setSelection('bra_cup_size', cupSize)"
                >
                  <div class="selected-background">
                    
                  </div>
                  <div class="hover-background"></div>
                  <div class="text-container">{{ cupSize }}</div>
                </div>
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>




      <v-layout column v-if="step == 'body'" key="step_body">

        <v-flex class="pb-0">
          <v-layout row>
            <v-flex xs12 class="text-xs-center">
              <h1>My body shape is...</h1>
            </v-flex>
          </v-layout>
          <v-layout row justify-center align-center my-0>
            <v-flex shrink style="min-height: 50px;" class="pt-2 pb-0">
              <span class="font-weight-bold"></span>
            </v-flex>
          </v-layout>
        </v-flex>

        <v-flex my-1>
          <v-layout row wrap justify-center class="ma-0 pa-0">
            <v-flex
              v-for="(bodyShape, bodyShapeIndex) in options.body_shapes"
              :key="'bodyShape-' + bodyShape.key"
              :data-index="bodyShapeIndex"
              xs6
              sm4
              md3
              lg2
              class="box-container pa-1 fitshape-container"
            >
              <v-hover>
                <div 
                  slot-scope="{ hover }"
                  class="box-subcontainer pa-2"
                  :class="{'hovering':hover, 'selected':(selections.body_shape == bodyShape.key)}"
                  @click="setSelection('body_shape', bodyShape.key)"
                >
                  <div 
                    class="img-container" 
                    :style="{backgroundImage: 'url(' + cdn + bodyShape.image + ')'}"
                  >
                  </div>
                  <div class="label-container font-weight-bold py-2">{{ bodyShape.label }}</div>
                </div> 
              </v-hover>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      
    </transition>

  </v-container>

</template>

<script>

import fitOptions from '@/consts/fitOptions';
import fitFields from '@/consts/fitFields';

export default {
  props: {
    prefill: Object,
    reverse: Boolean
  },
  name: 'Fit',
  data () {
    return {
      step: (this.reverse ? 'body' : 'height'),

      selections: JSON.parse(JSON.stringify(this.$store.getters.fit)),

      wizard: [
        'height',
        'top',
        'dress',
        'jean',
        'pants',
        'bra',
        'body'
      ],

      options: fitOptions
    }
  },
  mounted: function() {
    this.toggleWizardNextPrev();
  },
  watch: {
    'selections': {
      handler: function(newVal, oldVal) {
        this.toggleWizardNextPrev();
        this.$emit('on-update', this.selections);
      },
      deep: true
    },
    'step': function(newVal, oldVal) {
      this.toggleWizardNextPrev();
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    nextDisabled: function() {
      if(this.step == 'height') {
        if( typeof this.selections.height_ft === 'undefined' ||
            this.selections.height_ft === null ||
            typeof this.selections.height_in === 'undefined' ||
            this.selections.height_in === null
        ) {
          return true;
        } else {
          return false;
        }
      }
      if(this.step == 'top') {
        return (typeof this.selections.top_size === 'undefined' || this.selections.top_size === null);
      }
      if(this.step == 'dress') {
        return (typeof this.selections.dress_size === 'undefined' || this.selections.dress_size == null);
      }
      if(this.step == 'jean') {
        return (typeof this.selections.denim_waist_size === 'undefined' || this.selections.denim_waist_size == null);
      }
      if(this.step == 'pants') {
        return (typeof this.selections.pant_size === 'undefined' || this.selections.pant_size == null);
      }
      if(this.step == 'bra') {
        if( typeof this.selections.bra_size === 'undefined' ||
            this.selections.bra_size === null ||
            typeof this.selections.bra_cup_size === 'undefined' ||
            this.selections.bra_cup_size === null
        ) {
          return true;
        } else {
          return false;
        }
      }
      if(this.step == 'body') {
        return (typeof this.selections.body_shape === 'undefined' || this.selections.body_shape == null);
      }

      return false;
    },
    previousDisabled: function() {
      return false;
    },
    stateFit: function() {
      return this.$store.getters.fit;
    }
  },
  methods: {
    toggleWizardNextPrev: function() {
      this.$nextTick( () => {
        this.$store.commit('setWizardNextDisabled', this.nextDisabled);
        this.$store.commit('setWizardPrevDisabled', this.previousDisabled);
      });
    },

    setSelection: function(key, val) {
      this.$set(this.selections, key, val);
    },

    nextStep: function() {
      if(!this.nextDisabled) {
        let cur_index = this.wizard.indexOf(this.step);

        
        //Build Post/Patch object
        /*let update_data = {};
        for(let i = 0; i < Object.keys( fitFields ).length; i++) {
          let key = Object.keys( fitFields )[i];
          if(this.selections[key] !== null) update_data[key] = this.selections[key];
        }*/


        
        this.$http.post('users/' + this.user.id + '/fit', this.selections)
          .then( response => {
            this.$store.commit('setFit', response.data);
          })
          .catch( error => {
            console.log(error);
          });
        


        if((cur_index + 1) == this.wizard.length) {
          this.$emit('on-complete', this.selections);
          return;
        }

        this.step = this.wizard[ cur_index + 1 ];
      }
    },
    previousStep: function() {
      if(!this.previousDisabled) {
        let cur_index = this.wizard.indexOf(this.step);

        if(cur_index === 0) {
          this.$emit('on-cancel');
          return;
        }

        this.step = this.wizard[ cur_index - 1 ];
      }
    },

    lastStep: function() {
      this.step = this.wizard[ this.wizard.length - 1 ];
    }
  }
}
</script>